{
  "dismiss": "Dispensar"
}
